import React, { Component } from 'react';

import { API_URLS } from '../../helpers/api/API_URLS';

import { InputRow } from '../../helpers/uiComponents/InputRow';

class CrmNewsletter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			defaults: {
				"templateId": null,
				"newsletter": null,
				"clientCode": null,
				"includeContacts": false,
				"includeLeads": false,
				"convertToUtc": true,
				"sendIfDupe": false,
				"fromName": null,
				"fromEmail": null,
			},
			file: null,
			allowValidate: false,
			allowSend: false,
			message: null,
			report: null,
			loading: false,
			error: false,
		}
		this.updateDefaults = this.updateDefaults.bind(this);
		this.validateList = this.validateList.bind(this);
		this.sendList = this.sendList.bind(this);
	}

	updateDefaults(e) {
		var key = e.target.name;
		var val = e.target.value;

		this.setState({allowSend: false});

		if (key !== "file") {
			if (val === "") { val = null }
			var update = this.state.defaults;
			if (key === "templateId") {
				update["newsletter"] = e.target.options[e.target.selectedIndex].text
			}
			if (key === "schedule") {
				val = val+":00";
			}
			
			if (e.target.type === "checkbox") {
				update[key] = e.target.checked;
			} else {
				update[key] = val;
			}
			
			this.setState({
				defaults: update
			});
		}
		
		//console.log(this.state.defaults);

		this.checkDefaults(this.state.defaults);
	}

	checkDefaults(defaults) {
		var hasEmpty = !Object.values(defaults).some(x => (x === null));
		if (hasEmpty) {
			// console.log("ready to validate")
			this.setState({allowValidate: true});
		}
	}

	validateList() {
		this.setState({
			report: null,
			message: null,
			loading: true,
			error: false,
		});
		let params = {
			headers: {
				// 'Content-Type': 'multipart/form-data',
				"authorization": "Bearer " + localStorage.getItem("token"),
			},
			method: 'POST'
		};
		params.body = new FormData();
		var file = document.getElementById('file').files[0];
		if (file) {
			params.body.append('file', file);
		}
		params.body.append('defaults', JSON.stringify(this.state.defaults));
		params.body.append('includeLeads', JSON.stringify(this.state.defaults.includeLeads));
		params.body.append('includeContacts', JSON.stringify(this.state.defaults.includeContacts));
		params.body.append('convertToUtc', JSON.stringify(this.state.defaults.convertToUtc));

		//console.log(params.body);
		//console.log(this.state.defaults);

		fetch(API_URLS.CRM1+"email/list/validate", params)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong validating the newsletter ...'); }
		})
		.then(data => {
			//console.log(data);
			this.setState({
				report: data.result,
				message: data.message,
				allowSend: data.success,
				loading: false,
				error: false,
			});
			
		})
		.catch(error => {
			console.log(error);
			this.setState({
				message: error.TypeError,
				error: true,
				loading: false,
			});
		});
	}

	sendList() {
		// console.log("Send List");
		this.setState({
			report: null,
			message: null,
			loading: true,
			error: false,
		});
		let params = {
			headers: {
				// 'Content-Type': 'multipart/form-data',
				"authorization": "Bearer " + localStorage.getItem("token"),
			},
			method: 'POST'
		};

		params.body = new FormData();
		var file = document.getElementById('file').files[0];
		if (file) {
			params.body.append('file', file);
		}
		params.body.append('defaults', JSON.stringify(this.state.defaults));

		//console.log(params);

		fetch(API_URLS.CRM1+"email/list", params)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong validating the newsletter ...'); }
		})
		.then(data => {
			// console.log(data);
			setTimeout(() => {
				this.setState({
					report: data.result,
					message: data.message,
					emailSent: data.success,
					loading: false,
					error: false,
				});
			}, 3000);
		})
		.catch(error => {
			console.log(error);
			this.setState({
				message: error,
				error: true,
				loading: false,
			});
		});
	}

	sortBy(prop) {
		var list = this.state.report;

		var sort = this.state.sortVal;
		if (sort === 0 || sort === 2) {
			list = list.sort((a, b) => (a[prop] > b[prop]) ? 1 : -1);
			sort = 1;
		} else {
			list = list.sort((a, b) => (a[prop] < b[prop]) ? 1 : -1);
			sort = 2;
		}	

		this.setState({
			report: list,
			sortVal: sort,  // up or down
		});
	}

	render () {
		const { allowValidate, allowSend, report, message, emailSent, loading, error } = this.state;

		const sgTemplates = this.props.sgTemplates;
		const clients = this.props.clients;

		return(
			<div>
				<section className="section campaign-test">
					<h3>Send Newsletter</h3>

					<form className="input-group">
						<InputRow onChange={this.updateDefaults} label="SendGrid Email Template" type="select" property="templateId" options={sgTemplates} />
						<InputRow onChange={this.updateDefaults} label="Client Name" type="select" options={clients} property="clientCode" />
						<InputRow onChange={this.updateDefaults} label="Send To Client's Leads?" type="checkbox" property="includeLeads" />
						<InputRow onChange={this.updateDefaults} label="Send To Custom List (.CSV or .XLSX only)" type="file" property="file" id="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" description="the ONLY column required is 'email'. all other columns should reflect variables in the template like 'firstName' " />
						<InputRow onChange={this.updateDefaults} label="Allow Template Duplicate Sends" type="checkbox" property="sendIfDupe" description="Sending an email template to the same email address more than one time is disabled by default. Only turn this on if a template can/should be sent to the same email address more than one time." />
						<InputRow onChange={this.updateDefaults} label="From Name" type="text" property="fromName" />
						<InputRow onChange={this.updateDefaults} label="From Email" type="text" property="fromEmail" />
						<InputRow onChange={this.updateDefaults} label="Publish Date/Time" type="datetime-local" property="schedule" />
					</form>
					
					<button className="button big-button" onClick={this.validateList} disabled={!allowValidate}>Step 1: Validate Newsletter Configuration</button>
					<button className="button big-button" onClick={this.sendList} disabled={!allowSend}>Step 2: Send Valid Newsletter</button>

					<div id="email-send-report" className="table">
						{(loading) && (
							<p style={{textAlign: 'center', marginTop: '40px'}}><i className="loading fas fa-spinner"></i></p>
						)}
						{(error) && (
							<p>There was an error processing your request.</p>
						)}
						{(report) && (
							<React.Fragment>
								<h4>
									{emailSent ? (
										<React.Fragment>
											<p>{allowSend ? ("email list was sent") : ("email list has errors, see results below and revalidate")}</p>
											<p>{message}</p>
										</React.Fragment>
									) :(
										<React.Fragment>
											<p>{allowSend ? ("email list is valid") : ("email list has errors, see results below")}</p>
											<p>{message}</p>
										</React.Fragment>
									)}
								</h4>
								<h4>results:</h4>
								<div className="table-heading">
									<div className="group-labels">
										<div>From</div>
										<div>To</div>
										<div>Source</div>
										<div onClick={() => this.sortBy("valid")}>Success <i className="fas fa-sort"></i></div>
										<div>Errors</div>
									</div>
								</div>
								<div className="table-body">
									{report.map((row, index) =>
										<li key={index}>
											<div>{row.email.fromEmail}</div>
											<div>{row.email.toEmail}</div>
											<div>{(row.email.leadId) ? ("Leads"):("CSV")}</div>
											<div>{(row.email.valid) ? ("True"):("False")}</div>
											<div>
												{Object.keys(row.errors).map((error, index) => row.errors[error] )}
											</div>
										</li>
									)}
								</div>
							</React.Fragment>
						)}
					</div>
				</section>
			</div>
		)
	}
}

export default CrmNewsletter;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/CrmNewsletter.js